import { useMemo, useState } from "react"

import { products } from "../data/products"
import { categories } from "../data/categories"

import SEO from "../components/common/SEO"
import PageBanner from "../components/layout/PageBanner"

import ProductSearch from "../components/products/ProductSearch"
import ProductFilters from "../components/products/ProductFilters"
import ProductGrid from "../components/products/ProductGrid"

export default function Products() {
  const [searchTerm, setSearchTerm] = useState("")
  const [selectedCategory, setSelectedCategory] =
    useState("all")

  const filteredProducts = useMemo(() => {
    const query = searchTerm.toLowerCase()

    return products.filter((product) => {
      const matchesSearch =
        product.name?.toLowerCase().includes(query) ||
        product.category?.toLowerCase().includes(query) ||
        product.description?.toLowerCase().includes(query) ||
        product.slug?.toLowerCase().includes(query)

      const matchesCategory =
        selectedCategory === "all" ||
        product.category === selectedCategory

      return matchesSearch && matchesCategory
    })
  }, [searchTerm, selectedCategory])

  const currentCategory =
    selectedCategory === "all"
      ? "Tous les produits"
      : categories.find(
          (cat) => cat.slug === selectedCategory
        )?.name

  return (
    <>
      <SEO
        title="Produits"
        description="Découvrez notre catalogue complet de fournitures textiles, mercerie, tissus, fermetures, fils, élastiques, velcro et accessoires."
        keywords="produits textile, mercerie, tissus, fermetures éclair, fils à coudre, velcro, grossiste textile"
        url="https://www.khenissitextiles.com/produits"
      />

      <PageBanner
        title="Nos Produits"
        subtitle="Découvrez notre large sélection de fournitures textiles destinées aux professionnels."
      />

      <section className="py-12 lg:py-16">
        <div className="container mx-auto px-4 lg:px-8">

          {/* Recherche */}
          <ProductSearch
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
          />

          {/* Filtres */}
          <div className="mt-6">
            <ProductFilters
              categories={categories}
              selectedCategory={selectedCategory}
              setSelectedCategory={setSelectedCategory}
            />
          </div>

          {/* Titre catégorie */}
          <div className="mt-10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">

            <h2 className="text-2xl font-bold text-gray-900">
              {currentCategory}
            </h2>

            <p className="text-gray-500">
              {filteredProducts.length} produit
              {filteredProducts.length > 1 ? "s" : ""}
              trouvé
              {filteredProducts.length > 1 ? "s" : ""}
            </p>

          </div>

          {/* Aucun résultat */}
          {filteredProducts.length === 0 ? (
            <div className="py-20 text-center">

              <h3 className="text-3xl font-bold text-gray-900">
                Aucun produit trouvé
              </h3>

              <p className="mt-4 text-gray-600">
                Essayez un autre mot-clé ou une autre catégorie.
              </p>

            </div>
          ) : (
            <div className="mt-10">
              <ProductGrid
                products={filteredProducts}
              />
            </div>
          )}

        </div>
      </section>
    </>
  )
}